import * as React from 'react';
import {generatePath} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {PageControlBar} from 'shells/control-bar/page-control-bar';
import {StatusBarSecondaryTimestamp} from 'shells/control-bar/status-bar-secondary-timestamp';
import {TabbedContent} from 'shells/layout/tabbed-content';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';

import {useGetInboxThreadCounts} from '../../graphql/hooks/use-get-inbox-thread-counts';

import {useGetChatSettings} from '../graphql/hooks/use-get-chat-settings';
import {useGetContextDocumentUsage} from '../graphql/hooks/use-get-context-document-usage';

import {getTabOptionsM2} from './helpers';

type Props = ContextRouter;

export function ChatSettingsM2(props: Props) {
    const {refetch} = useGetChatSettings();
    const {inboxThreadCounts, isLoading: isLoadingInboxThreadCounts} = useGetInboxThreadCounts(
        {
            assignees: [],
        },
        true
    );
    const {hasNoContent} = useGetContextDocumentUsage();

    const selectedTab = props.match.params.id || 'appearance';
    const setSelectedTab = (newTab: string) => {
        const newPath = generatePath(props.match.path, {
            section: 'settings',
            page: 'chat',
            id: newTab,
        });

        props.history.push({
            pathname: newPath,
            search: props.history.location.search,
        });
    };

    let secondaryText = 'Embed and enable chat to start receiving chats from your visitors';
    if (isLoadingInboxThreadCounts) {
        // @ts-expect-error
        secondaryText = <LoadingText height={20} width={200} />;
    } else if (inboxThreadCounts.chat.lastStartedTime) {
        // @ts-expect-error
        secondaryText = (
            <StatusBarSecondaryTimestamp
                datetime={inboxThreadCounts.chat.lastStartedTime}
                prefix='Last chat started'
                emptyText='Nobody has chatted in yet'
                displayConfig={{
                    type: 'datetime',
                    format: FormattedTimestamp.formats.monthDayYear,
                }}
                showDetailedPopover={true}
            />
        );
    }

    return (
        <div className='flex flex-dir-col flex-grow'>
            <PageControlBar
                statusInfo={{primaryText: null, secondaryText}}
                tabs={{
                    selectedTab,
                    options: getTabOptionsM2(hasNoContent, refetch),
                    onChangeTab: (newTab) => setSelectedTab(newTab),
                }}
            />
            {/* @ts-expect-error */}
            <TabbedContent
                selectedTab={selectedTab}
                tabOptions={getTabOptionsM2(hasNoContent, refetch)}
            />
        </div>
    );
}
